
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/copyright/countries",
      function () {
        return require("private-next-pages/copyright/countries/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/copyright/countries"])
      });
    }
  